import React from "react";
import { SvgIcon } from "assets/icons";

const CheckedIcon = ({ checked }) => {
  return checked ? <SvgIcon.SuccessIcon /> : <SvgIcon.CloseIcon />;
};

export default CheckedIcon;
